function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#BFBBB7",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.897 7.298c0-.23-.19-.418-.425-.418H9.219a.421.421 0 0 0-.425.418v3.34c0 .23.19.417.425.417h4.253a.421.421 0 0 0 .425-.417v-3.34zm-.85 2.922H9.643V7.715h3.402v2.505z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.775 7.753l-1.696-.835a.426.426 0 0 0-.568.187.414.414 0 0 0 .192.56l.645.317c-.017.045-.04.093-.04.145 0 .543.416 1.002.841 1.175v5.087c0 .23-.19.418-.425.418a.422.422 0 0 1-.425-.418v-3.34c0-1.008-.85-1.851-1.701-2.045V6.457c0-.921-.743-1.664-1.68-1.664H8.813c-.938 0-1.721.743-1.721 1.664V15.8l-.616.302a.417.417 0 0 0-.235.374v1.252c0 .23.21.424.446.424h9.355c.235 0 .405-.193.405-.424v-1.252a.417.417 0 0 0-.235-.374l-.615-.302V9.874c.425.172.85.632.85 1.175v3.34c0 .69.573 1.253 1.276 1.253.704 0 1.276-.562 1.276-1.253V8.127a.407.407 0 0 0-.225-.374zm-3.177 9.565H7.093v-.583l.615-.302a.417.417 0 0 0 .235-.374V6.457c0-.46.402-.83.871-.83h5.103c.47 0 .83.37.83.83v9.602c0 .158.091.303.235.374l.616.302v.583z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#BFBBB7",
  strokeWidth: 0.718,
  d: "M3.906 17.43V1.162a.803.803 0 0 0-.802-.803h-.905a.803.803 0 0 0-.803.803V17.38a2.22 2.22 0 0 1 2.51.05zM4.106 1.144v16.65h11.129V3.284l-2.544-2.14H4.106z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BFBBB7",
  strokeWidth: 0.718,
  d: "M12.826 1.025v2.296h2.6M11.348 19.766L3.42 17.43c-.698-.111-1.15-.126-1.513-.007-.434.141-.655.477-.643 1.177 0 .642.536 1.166 1.201 1.166h8.883z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BFBBB7",
  strokeWidth: 0.722,
  d: "M13.792 19.735h-2.506"
}));

var SvgIfta = function SvgIfta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIfta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ifta.610ea44f.svg";
export { ForwardRef as ReactComponent };